import { render, staticRenderFns } from "./App.vue?vue&type=template&id=427e03fd&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=427e03fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_epdqlcc3dmzbifjpwlzkpsihom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427e03fd",
  null
  
)

export default component.exports